let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dJLWv")).then(() => parcelRequire('lxZVf'));